import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { LoginService } from '@app/login/services';

@Component({
  selector: 'app-punchout',
  templateUrl: './punchout.page.html',
})
export class PunchoutPage implements AfterViewInit {
  form: FormGroup;
  browserFormPost: string;

  constructor(private loginService: LoginService) {
    this.browserFormPost = localStorage.getItem('browserFormPost');
    this.form = new FormGroup({
      'cXML-urlencoded': new FormControl(localStorage.getItem('orderXML')),
    });
  }

  ngAfterViewInit() {
    if (this.browserFormPost && this.form.valid) {
      localStorage.removeItem('browserFormPost');
      localStorage.removeItem('orderXML');
      this.submitForm();
    } else {
      this.loginService.logout();
    }
  }

  submitForm() {
    const formElement = document.getElementById(
      'externalForm',
    ) as HTMLFormElement;
    formElement.submit();
  }
}
